
































import {
  Component,
  Prop,
  Vue
} from "@/shared/vuepack";
import {
  hsabExpenseOriginatorTypeMap,
  ManagedExpenseResponse
} from "@/shared/types";
import moment from "moment/moment";
import CurrencyAmount from "@/shared/components/ui/CurrencyAmount.vue";
import Pill from "@/shared/components/ui/Pill.vue";
import {
  expenseCategoryIcon,
  expenseSourceIcon
} from "@/shared/awesomeIconMapper";

import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";
import HsabExpenseReimbursementStatusPill from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseReimbursementStatusPill.vue";

@Component({
  components: {
    HsabExpenseReimbursementStatusPill,
    Pill,
    CurrencyAmount
  }
})
export default class ActionNeededExpenseWidgetRow extends Vue {
  hsabAccountsStore = useHsabAccountsStore();
  expenseCategoryIcon = expenseCategoryIcon;
  expenseSourceIcon = expenseSourceIcon;
  hsabExpenseOriginatorTypeMap = hsabExpenseOriginatorTypeMap;

  @Prop({ required: true })
  managedExpense: ManagedExpenseResponse;

  @Prop()
  showPlanName: boolean;

  get formattedDate (): string {
    return moment(this.managedExpense.dateOfService).format("MMM D, YYYY");
  }
  get formattedOriginator () {
    if (this.managedExpense.originator) {
      return this.hsabExpenseOriginatorTypeMap[this.managedExpense.originator];
    }
    return "Unknown";
  }
}
